import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const UpdateStatusContext = createContext(null);

type Props = {
  children: ReactElement;
};

const UpdateStatusProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        `backoffice/onboarding/risk-profiles/${id}`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <UpdateStatusContext.Provider value={contextValue}>
      {children}
    </UpdateStatusContext.Provider>
  );
};

export default UpdateStatusProvider;
